// @ts-nocheck
// import Vue from 'vue'
/* Load global components */
import {
  FormCheckboxPlugin,
  ModalPlugin,
  PaginationPlugin,
  SkeletonPlugin,
  ToastPlugin,
  VBModal,
  VBPopover,
  VBToggle,
  VBTooltip,
  FormRadioPlugin
} from 'bootstrap-vue/esm'
import Multiselect from 'vue-multiselect'

Multiselect.props.selectLabel.default = '選択'
Multiselect.props.selectGroupLabel.default = '選択'
Multiselect.props.selectedLabel.default = '選択済'
Multiselect.props.deselectLabel.default = '選択解除'
Multiselect.props.deselectGroupLabel.default = '選択解除'
Multiselect.props.placeholder = { default: '---' }
Multiselect.props.tagPlaceholder = {
  default: 'エンターを押して追加できます',
}


export const CORELoadCommonComponent = (Vue) => {
  Vue.directive('b-modal', VBModal)
  Vue.directive('b-popover', VBPopover)
  Vue.directive('b-toggle', VBToggle)
  Vue.directive('b-tooltip', VBTooltip)
  Vue.use(SkeletonPlugin)
  Vue.use(ModalPlugin)
  Vue.use(ToastPlugin)
  Vue.use(FormCheckboxPlugin)
  Vue.use(PaginationPlugin)
  Vue.use(FormRadioPlugin)

  if (!Vue.prototype.$models) {
    Vue.prototype.$models = {}
  }
  // Vue.use(BootstrapVue)
  Vue.component(
    'Datepicker',
    () => import('../components/form/datepicker.vue'),
  )
  Vue.component(
    'Devcomment',
    () => import('../components/devcomment.vue'),
  )
  Vue.component('Multiselect', Multiselect)
  Vue.component(
    'Helpicon',
    () => import('../components/helpicon.vue'),
  )
  // Vue.component('VueMarkdown', async () => {
  //   const VueMarkdown = await import('vue-markdown')
  //   VueMarkdown.props.toc.default = true
  //   VueMarkdown.props.tocId.default = 'vue-md-toc'
  //   return VueMarkdown
  // })
  Vue.component(
    'Loading',
    () => import('../components/loading.vue'),
  )
  Vue.component(
    'HistoryBackButton',
    () =>
      import('../components/historyBackButton.vue'),
  )
  Vue.component(
    'AppHookableComponent', () => import('../components/AppHookableComponent.vue'),
  )
}


/* End of load global components */
